import React from "react";
import { CssBaseline, Divider } from "@material-ui/core";

import {
  Box,
  Typography,
  
} from "@material-ui/core";
import LoadingButton from "../../LoadingButton/LoadingButton";
import Step2 from "../../Components/Step2";
import Step1 from "../../Components/Step1";
import { useSnackbar } from "notistack";

import { Button, Stepper } from "@material-ui/core";
const InitialPage = ({
  Formdata,
  showPassword,
  setshowPassword,
  checkRedeemAvailability,
  checkTenantAvailability,
  emailAvailable,
  checkEmailAvailability,
  redemptionCodeAvailable,
  setRedemptionCodeAvailable,
  updateTempData,
  tenantCodeAvailable,
  loading, setLoading,
  setEmailAvailable
}) => {



  const { enqueueSnackbar } = useSnackbar();
const showRedemptionCode = true;
  function getSteps() {
    return ["Basic Settings", "Domain Details"];
  }
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  async function handleNext() {
    try {
      // let t =   await checkEmailAvailability(Formdata.values.email);
      // if(t === "TD005: Already company registerd with this EMAIL ID"){
      //     setLoading(false);
      //     return;   
      //   }
      await updateTempData();
      setLoading(false);
      if(Formdata.values.redemption !==""){
        await checkRedeemAvailability();
      }
      
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } catch (err) {
      console.log(err);
    }
  }
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <Step1
            Formdata={Formdata}
            showPassword={showPassword}
            checkEmailAvailability={checkEmailAvailability}
            emailAvailable={emailAvailable}
            setshowPassword={setshowPassword}
            checkTenantAvailability={checkTenantAvailability}
            tenantCodeAvailable={tenantCodeAvailable}
            setEmailAvailable={setEmailAvailable}
          />
        );
      case 1:
        return (
          <>
            <Step2
              Formdata={Formdata}
              showPassword={showPassword}
              setshowPassword={setshowPassword}
              checkTenantAvailability={checkTenantAvailability}
              tenantCodeAvailable={tenantCodeAvailable}
              checkRedeemAvailability={checkRedeemAvailability}
              redemptionCodeAvailable={redemptionCodeAvailable}
              setRedemptionCodeAvailable={setRedemptionCodeAvailable}
              showRedemptionCode = {showRedemptionCode}
            />
          </>

        );
      default:
        return "Unknown step";
    }
  }

  
  return (
    <Box height="100%" width="100%">
      <Box

        width="20%"
        display="flex"
        alignItems="center"
        top={0}
        left={0}
        margin={5}
      >
        <Box mr={1}>
          <a href="https://www.growmax.io/">
            <img
              src="https://uploads-ssl.webflow.com/5fba92e02f240050de6a1ccd/5fbe2d1d07b3fc2421d6f39b_growmax_red.svg"
              alt="logo"
              height="100%"
              width="100%"
              style={{ objectFit: "contain", objectPosition: "left" }}
            />
          </a>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box ml={1} mb={-0.75}>
          <a href="https://www.growmax.io/">
            <img
              src="/APPSUMO.png"
              alt="logo"
              height="100%"
              width="100%"
              style={{ objectFit: "contain", objectPosition: "left" }}
            />
          </a>
        </Box>
      </Box>
      <CssBaseline />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Box width="50%" margin="0 auto">
          <Typography
            gutterBottom
            align="center"
            variant="h4"
            style={{ fontWeight: 500 }}
          >
            Hey Sumo-lings! Get Started
          </Typography>
          <Typography align="center" variant="subtitle1">
            Please share your details below along with Appsumo Code to
            launch your B2B commerce now to reach more customers & increase
            sales.
          </Typography>
          <Box
            height="100%"
            display="flex"
            flexDirection="column"
            pt={4}
            width="50%"
            m="0 auto"
            sx={{ "& .MuiFormControl-root": { margin: "8px 0" } }}
          >
            <Stepper
              elevation={0}
              square
              style={{
                backgroundColor: "inherit",
              }}
              activeStep={activeStep}
            >
            </Stepper>
            <Box mb={3} mt={1}>
              {activeStep === steps.length ? (
                <div>
                  <Typography>
                    All steps completed - you&apos;re finished
                  </Typography>
                </div>
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                >
                  {getStepContent(activeStep)}
                </Box>
              )}
            </Box>
            <Box display="flex" justifyContent="center">
              {activeStep === steps.length ? null : (
                <>
                  {activeStep !== 0 ?
                    <Button disabled={activeStep === 0} onClick={handleBack}>
                      Back
                    </Button>
                    : null

                  }

                  <Box m={1} />
                  <LoadingButton
                    variant="contained"
                    loading={loading}
                    color="primary"
                    value={activeStep === steps.length - 1 ? "Create Store" : "Create account"}
                    onClick={(e) => {
                      setLoading(true);
                      if(loading){
                        return;
                      }
                      if(activeStep === steps.length - 1){
                        checkRedeemAvailability();
                      }
                      if (
                        activeStep !== steps.length - 1 &&
                        Formdata.values.email !== "" &&
                        Formdata.values.password !== "" &&
                        // !emailAvailable &&
                        Formdata.errors.email === undefined &&
                        Formdata.errors.password === undefined
                      ) {
                        handleNext();
                      } else {
                        if (
                          Formdata.isValid &&
                          Formdata.values.email !== "" &&
                          Formdata.values.password !== ""
                        ) {
                          if (activeStep === steps.length - 1) {
                            if (window.location.pathname.includes("appsumo")) {
                              if(redemptionCodeAvailable){
                                setLoading(false);
                                return;
                              }
                              if (!redemptionCodeAvailable) {
                                // handleNext();
                                Formdata.handleSubmit(e);
                              }
                            } else {
                              // handleNext();
                             Formdata.handleSubmit(e);
                             setLoading(false);
                            }
                          }
                        } else {
                          setLoading(false);
                          enqueueSnackbar("Please fill all mandatory fields", {
                            variant: "info",
                            preventDuplicate: true,
                          });
                        }
                      }
                    }}
                  >
               </LoadingButton>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>

  );
};

export default InitialPage;
